module.exports = __webpack_public_path__ + "static/media/Football-Tournament.4aa50b3b.png";